import { useState } from "react";
import { Menu, X as XIcon } from "lucide-react";

export const NAV_ITEMS = Object.freeze([
    { id: "platform", label: "Platform" },
    { id: "solutions", label: "Solutions" },
    { id: "customers", label: "Customers" },
    { id: "security", label: "Security" },
    { id: "pricing", label: "Pricing" },
    { id: "resources", label: "FAQ" },
]);

export default function Nav({
    navItems,
    scrolledPast,
    scrollTo,
    onBook,
    onCapability,
}) {
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleBook = () => {
        setMobileOpen(false);
        onBook();
    };

    const handleCapability = () => {
        setMobileOpen(false);
        onCapability();
    };

    const handleNav = (id) => {
        setMobileOpen(false);
        setTimeout(() => scrollTo(id), 50);
    };

    return (
        <>
            <header
                className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                    scrolledPast
                        ? "bg-[#0A0A0A]/85 backdrop-blur-md border-b border-white/10"
                        : "bg-transparent"
                }`}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
                    <button
                        onClick={() => scrollTo("hero")}
                        className="flex items-center gap-3"
                        data-testid="brand-mark"
                        aria-label="Edara Software home"
                    >
                        <img
                            src="/edara-logo.png"
                            alt=""
                            className="w-12 h-12 sm:w-14 sm:h-14 object-contain"
                        />
                        <span className="font-display text-2xl sm:text-[26px] tracking-wider text-white">
                            EDARA <span className="text-[#1FA8FF]">SOFTWARE</span>
                        </span>
                    </button>

                    <nav className="hidden lg:flex items-center gap-8">
                        {navItems.map((n) => (
                            <button
                                key={n.id}
                                onClick={() => scrollTo(n.id)}
                                className="text-sm text-zinc-300 hover:text-white transition-colors"
                                data-testid={`nav-${n.id}`}
                            >
                                {n.label}
                            </button>
                        ))}
                    </nav>

                    <div className="hidden lg:flex items-center gap-3">
                        <button
                            onClick={handleBook}
                            className="text-sm text-zinc-300 hover:text-white px-3 py-2"
                        >
                            Sign in
                        </button>
                        <button
                            onClick={handleBook}
                            className="px-4 py-2.5 rounded-lg bg-[#1FA8FF] text-white text-sm font-semibold hover:bg-[#0C84D4] transition-colors"
                            data-testid="nav-book-demo"
                        >
                            Book a demo
                        </button>
                    </div>

                    <button
                        className="lg:hidden p-2 -mr-2"
                        aria-label="Open menu"
                        onClick={() => setMobileOpen(true)}
                        data-testid="mobile-menu-open"
                    >
                        <Menu className="w-6 h-6 text-white" />
                    </button>
                </div>
            </header>

            {mobileOpen && (
                <div
                    className="fixed inset-0 z-[60] lg:hidden bg-[#0A0A0A]"
                    role="dialog"
                    aria-modal="true"
                    data-testid="mobile-nav"
                >
                    <div className="flex items-center justify-between h-20 px-4 border-b border-white/10">
                        <span className="flex items-center gap-3">
                            <img
                                src="/edara-logo.png"
                                alt=""
                                className="w-10 h-10 object-contain"
                            />
                            <span className="font-display text-2xl tracking-wider">
                                EDARA{" "}
                                <span className="text-[#1FA8FF]">SOFTWARE</span>
                            </span>
                        </span>
                        <button
                            onClick={() => setMobileOpen(false)}
                            aria-label="Close menu"
                            className="p-2 -mr-2"
                        >
                            <XIcon className="w-6 h-6" />
                        </button>
                    </div>
                    <div className="px-6 py-8 space-y-1">
                        {navItems.map((n) => (
                            <button
                                key={n.id}
                                onClick={() => handleNav(n.id)}
                                className="block w-full text-left py-4 text-2xl font-display tracking-wide text-white border-b border-white/10"
                            >
                                {n.label}
                            </button>
                        ))}
                        <div className="pt-6 flex flex-col gap-3">
                            <button
                                onClick={handleBook}
                                className="w-full px-4 py-3.5 rounded-lg bg-[#1FA8FF] text-white font-semibold"
                            >
                                Book a demo
                            </button>
                            <button
                                onClick={handleCapability}
                                className="w-full px-4 py-3.5 rounded-lg border border-white/20 text-white font-semibold"
                            >
                                Download capability statement
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
